export default __webpack_public_path__ + "static/media/fuckTheRich.8acfa8cd.png";